export default "__VITE_ASSET__DD68pPRZ__"